<template>
  <div v-if="visible" class="popup-mask" @click="handleMaskClick">
    <div class="popup-panel" @click.stop>
      <div class="popup-title">{{ title }}</div>
      <div class="popup-content">{{ content }}</div>
      <div class="popup-actions">
        <button class="popup-btn" type="button" @click="handleConfirm" code-stm="event, PAGEURL, 提示弹窗点击按钮">
          {{ buttonText || '确定' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: '确定'
    }
  },
  methods: {
    handleMaskClick() {
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    }
  }
}
</script>

<style scoped lang="scss">
.popup-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.popup-panel {
  background: #fff;
  width: 86%;
  height: 30%;
  max-height: 300px;
  min-height: 200px;
  max-width: 420px;
  padding: 22px 18px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.popup-title {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: 18px;
  color: #111;
  text-align: center;
}
.popup-content {
  margin-top: 12px;
  font-family: "FZLanTingHeiS-R-GB";
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  text-align: center;
}
.popup-actions {
  margin-top: 18px;
  display: flex;
  justify-content: center;
}
.popup-btn {
  appearance: none;
  border: none;
  background: #000;
  color: #fff;
  border-radius: 4px;
  padding: 10px 22px;
  font-size: 14px;
  cursor: pointer;
}
</style>

